/** Points written to DB `stage5` on success. */
export const NEWSPAPER_POINTS = 100;

/** Puzzle 6 reuses trophy_vault entry once stage5 is cleared. */
export const NEWSPAPER_UNLOCKS = "trophy_vault";

export const VAULT_PASSWORD = "CHAK DE INDIA";

/** Letter slots for password entry UI (spaces omitted as visual gaps). */
export const VAULT_PASSWORD_CHARS = VAULT_PASSWORD.replace(/ /g, "").split("");

/** Group sizes for CHAK | DE | INDIA display gaps. */
export const VAULT_PASSWORD_GROUPS = [4, 2, 5];

/**
 * Clickable letter ids inside `newspapaper_desk.svg` (order = CHAK DE INDIA).
 * `id` must match the SVG element id exactly.
 * `count` > 1 means one click collects that letter multiple times (e.g. both A's).
 */
export const NEWSPAPER_LETTERS = [
  { id: "C", letter: "C" },
  { id: "H", letter: "H" },
  { id: "A", letter: "A", count: 2 },
  { id: "K", letter: "K" },
  { id: "D", letter: "D" },
  { id: "E", letter: "E" },
  { id: "I", letter: "I" },
  { id: "N", letter: "N" },
  { id: "D2", letter: "D" },
  { id: "I2", letter: "I" },
];

/** Total letters needed for the vault password (accounts for multi-count clicks). */
export const NEWSPAPER_LETTER_TARGET = NEWSPAPER_LETTERS.reduce(
  (sum, l) => sum + (l.count || 1),
  0
);

/** Normalize for comparison: trim, collapse spaces, uppercase. */
export function normalizeVaultPassword(value) {
  return String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase();
}

/** Compare ignoring spaces and case. */
export function isVaultPasswordCorrect(value) {
  const typed = normalizeVaultPassword(value).replace(/ /g, "");
  const expect = VAULT_PASSWORD.replace(/ /g, "");
  return typed === expect;
}
